<!-- eslint-disable -->
<template>
<loading v-model:active="isLoading" :is-full-page="fullPage" />
<div id="auth">
    <div class="row h-100">
        <div class="col-lg-4 col-12">
            <div id="auth-left">
                <div class="auth-logo">
                  <router-link :to="{path: '/'}"><img src="/images/logo/logoBPP.png?ver=0.1.6" alt="Logo"></router-link>
                </div>
                <p class="auth-subtitle mb-3">Registrasi Akun</p>
                
                <form v-on:submit.prevent="searchnik" v-show="!formCreate">
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formSearch.nama_lengkap"  placeholder="Nama lengkap">
                        <div class="form-control-icon">
                            <i class="bi bi-person"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl datepicker date" 
                        v-bind:value="$filters.formatTanggal(formSearch.tanggal_lahir)" 
                        v-on:change="formSearch.tanggal_lahir = $event.target.value" 
                        v-on:input="formSearch.tanggal_lahir = $event.target.value" 
                        placeholder="Tanggal/Bulan/Tahun">
                        <div class="form-control-icon">
                            <i class="bi bi-calendar"></i>
                        </div>
                    </div>
                    
                    <button class="btn btn-warning btn-block btn-lg shadow-lg mt-4">CARI DATA SAYA</button>
                </form>

                <form v-on:submit.prevent="createAkun" v-show="formCreate">
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formVal.nomor"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-bookmark-check"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl" v-model="formVal.nama_lengakp"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-person-circle"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formVal.tanggal_lahir"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-calendar"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formVal.alamat"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-geo"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formVal.telpon"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-telephone-fill"></i>
                        </div>
                    </div>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formVal.nama_ayah"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-person-square"></i>
                        </div>
                    </div>
                    <p class="auth-label mt-5">Username Login</p>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formRegs.username"  placeholder="" readonly>
                        <div class="form-control-icon">
                            <i class="bi bi-person"></i>
                        </div>
                    </div>

                    <p class="auth-label mt-5">Masukan Password</p>
                    <div class="form-group position-relative has-icon-left mb-4">
                        <input type="text" class="form-control form-control-xl"  v-model="formRegs.password"  placeholder="">
                        <div class="form-control-icon">
                            <i class="bi bi-shield-lock"></i>
                        </div>
                    </div>
                  
                    <button class="btn btn-primary btn-block btn-lg shadow-lg mt-4">Daftar Akun</button>
                </form>

                <div class="text-center mt-5 text-lg fs-4">
                    <p class="text-gray-600">Sudah Memiliki Akun? <router-link :to="{path: '/'}" class="font-bold">Login</router-link>.</p>
                </div>
            </div>
        </div>
        <div class="col-lg-8 d-lg-block">
            <div id="auth-right">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="card bg-transparant">
                            <div class="bg-card"
                                style="position: absolute;height: 100%;background-color: #e1eefc;display: block;width: 100%; border-radius: 0.7rem; opacity: 0.2;">
                            </div>
                            <div class="card-content">

                                <div class="card-body">
                                    <h4 class="card-title text-dark text-left mt-2">Cara Registrasi Akun</h4>
                                    <ol class="card-text text-dark">
                                      <li>Pada halaman ini anda diminta untuk memasukan Nama Lengkap dan Tanggal Lahir Siswa</li>
                                      <li>Setelah Nama Lengkap dan Tanggal Lahir dimasukan klik tombol <strong>CARI DATA
                                          SAYA</strong></li>
                                       <li>Kemudian akan ditampilkan Informasi Nomor Induk BPP (NIB) <i
                                           class="bi bi-bookmark-check"></i> dan Biodata Siswa. Jika biodata yang
                                         ditampikan sudah sesuai dengan biodata anda, lalu isikan Password yang
                                         anda inginkan. <br>
                                         <label class="text-danger">Catatan : username login yang ditampilkan adalah NIB
                                           (Nomor Induk BPP) siswa, orang tua siswa diharapkan menghafalkan Nomor Induk
                                           BPP (NIB) siswa</label> <br>
                                       </li>
                                      <li>Langkah terakhir klik tombol <strong>DAFTAR AKUN</strong></li>
                                      <li>Setelah pendaftaran berhasil, anda akan di alihkan ke halaman login. Masukan Nomor Induk BPP (NIB) <i class="bi bi-bookmark-check"></i> dan password yang anda buat</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<!-- eslint-disable -->
<script>
  import axios from "axios";
  import moment from 'moment';
  import Loading from "vue-loading-overlay";

  export default {
    name: "Login",
    components: {
      Loading
    },
    data() {
      return {
        formVal : [],
        formRegs : [],
        formSearch : {
          nama_lengkap : '',
          tanggal_lahir : this.format_date(new Date())
        },
        isLoading: false,
        fullPage: true,
        formCreate:false,
      };
    },
    mounted() {
      this.loadPageRegister();
    },
    methods: {
      format_date(value){
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      async loadPageRegister() {
        this.isLoading = true;
      // this.formSearch.tanggal_lahir = this.format_date(new Date());
        $('.datepicker').datepicker({
          clearBtn: true,
          format: "dd/mm/yyyy"
        });
        setTimeout(() => {
          this.isLoading = false;
        },1000);
      },
      async searchnik() {
        this.isLoading = true;
      
        await axios.post('/api/public/searchsiswa',JSON.stringify(this.formSearch)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            let row = data.records;
            setTimeout(() => {
              this.isLoading = false;
              this.formCreate = true;
              this.formVal = {
                nomor : row.nis,
                nama_lengakp : row.nama,
                tanggal_lahir : row.tanggal_lahir,
                alamat : row.alamat,
                telpon : row.telpon,
                nama_ayah : 'Ayah : '+row.nama_ayah
              }
              this.formRegs = {
                key : data.key,
                nik : row.nom_kk,
                username : row.nis,
                password : '',
              }
            },100);
          }
          else {
            this.isLoading = false;
            Swal.fire({
              icon: "warning",
              title: "Maaf !",
              text: data.message,
            })
          }
        });
      },
      async createAkun() {
        this.isLoading = true;
        await axios.post('/api/public/createakun',JSON.stringify(this.formRegs)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            let row = data.records;
            this.isLoading = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              text: 'Akun anda berhasil dibuat',
            });
            setTimeout(() => {
              this.$router.push({ path: '/' })
            },3000);
          }
          else {
            this.isLoading = false;
            Swal.fire({
              icon: "warning",
              title: "Maaf !",
              text: data.message,
            })
          }
        });
      }
    }
  };
</script>
